<template>
  <div class="scroll-table">
    <div class="scroll-bar">
      <!-- <span>最近成交</span> -->
      <div class="scroll-bar-header row">
        <span class="record-time">成交时间</span>
        <span class="record-content">成交货物</span>
        <span class="record-from">始发地</span>
        <span class="record-to">目的地</span>
        <span class="record-weight">吨位</span>
        <span class="record-money">货主价格</span>
        <span class="record-phone">手机号码</span>
        <span class="record-status">成交状态</span>
      </div>
    </div>
    <div class="scroll-body">
      <ul class="rows" ref="STable" v-if="recordList.length">
        <li class="row" v-for="(record, index) in recordList" :key="index">
          <span class="record-time">{{ record.arrangeTime }}</span>
          <span class="record-content">{{ record.goods_name }}</span>
          <span class="record-from">{{ record.cityFrom }}</span>
          <span class="record-to">{{ record.cityTo }}</span>
          <span class="record-weight">{{ record.realTotalWeight }} 吨</span>
          <span class="record-money">{{ record.realTotalMoney }} 元</span>
          <span class="record-phone">{{ record.phone }}</span>
          <span class="record-status">{{ record.status }}</span>
        </li>
      </ul>
      <ul class="rows_duplicate" v-if="recordList.length">
        <li class="row" v-for="(record, index) in recordList" :key="index">
          <span class="record-time">{{ record.arrangeTime }}</span>
          <span class="record-content">{{ record.goods_name }}</span>
          <span class="record-from">{{ record.cityFrom }}</span>
          <span class="record-to">{{ record.cityTo }}</span>
          <span class="record-weight">{{ record.realTotalWeight }} 吨</span>
          <span class="record-money">{{ record.realTotalMoney }} 元</span>
          <span class="record-phone">{{ record.phone }}</span>
          <span class="record-status">{{ record.status }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Record from '@/models/Record';

export default {
  name: 'scroll-table',
  data() {
    return {
      interval: null,
      timer: 0,
      transformLength: 0,
      transformLength2: 0
    }
  },
  props: {
    records: {
      type: Array,
      required: true
    }
  },
  computed: {
    recordList() {
      if (!this.records || this.records.length == 0) {
        return new Array(8).fill(new Record(new Date(), '没有货物信息', '1**********', '无状态'));
        // return [];
      }
      let returnValue = [].concat(this.records);
      while (returnValue.length < 8) {
        returnValue = returnValue.concat(returnValue);
      }
      return returnValue;
    }
  },
  methods: {
    startScrollInterval() {
      if (this.interval)  this.stopScrollInterval();
      const rows = this.$el.querySelector('.rows');
      const rows_dup = this.$el.querySelector('.rows_duplicate');

      const rowHight = this.$el.querySelector('.row').scrollHeight;

      this.interval = setInterval(() => {

        if (this.transformLength < rows.scrollHeight * -1) {
          this.transformLength = 0;
          this.transformLength2 = 0;
        }

        this.transformLength -= 1;
        this.transformLength2 -= 1;

        rows.style.transform = `translate3d(0, ${this.transformLength}px, 0)`;
        rows_dup.style.transform = `translate3d(0, ${this.transformLength2}px, 0)`;

      }, 1000 / 40);
    },
    mouseInHandler() {
      this.stopScrollInterval();
    },
    mouseOutHandler() {
      this.startScrollInterval();
    },
    stopScrollInterval() {
      clearInterval(this.interval);
    }
  },
  mounted() {
    this.startScrollInterval();
    const STable = this.$refs.STable;
    if (STable) {
      STable.addEventListener('mouseover', () => this.stopScrollInterval());
      STable.addEventListener('mouseout', () => this.startScrollInterval());
    }
  },
  beforeDestroy() {
    this.stopScrollInterval();
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "../style/_variable";
.scroll-table {
  .scroll-bar {
    width: 100%; // height: 48px;
    line-height: 48px;
    text-align: center;
    background-color: $bg-clr;
    &-header span {
      color: $text-clr_light;
    }
  }

  .scroll-body {
    height: 400px;
    overflow: hidden;
  }

  .rows {
    cursor: pointer;
    background-color: #fff; // transition: all 1s linear;
    &_duplicate {
      background-color: #fff; // transition: all 1s linear;
    }
  }

  .row {
    align-items: center;
    width: 100%;
    overflow: hidden;
    border-bottom: 1px solid $border-clr; // padding: 0 10px;
    span {
      color: $text-clr_light;
      text-align: center;
      float: left;
      width: 140px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      height: 48px;
      line-height: 48px;
    }
    .record {
      &-time {
        width: 200px;
      }
      &-content {
        width: 120px;
      }
      &-from,
      &-to {
        width: 150px;
      }
      &-money {
        width: 100px;
      }
      &-phone {
        width: 100px;
      }
      &-weight {
        width: 150px;
      }
      &-status {
        width: 100px;
        text-align: right;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/scroll-table.vue